import React from 'react';
import moment from 'moment';

const WidgetWritetime = (props) => {
  const times = moment(new Date()).format('HH:mm:ss');
  //console.log(props);
  //console.log(times);
  return (
    <div>
      <div>{times}</div>
    </div>
  );
};

export default WidgetWritetime;
